import React, { memo, useContext } from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';

import ErrorMessage from '../../components/error-message';
import ErrorBoundary from '../../components/error-boundary';
import CookieBanner from '../../components/cookie-banner';

import AdContainer from '../../components/ads';
import { withAds } from '../../components/ads/context';
import AdServiceContextType from '../../components/ads/context/type';

import './index.scss';

const LoadableHeader = loadable(() =>
  import(/* webpackChunkName: "legacy" */ './header')
);

const LoadableFooter = loadable(() =>
  import(/* webpackChunkName: "legacy" */ './footer')
);

const styles = bemGenerator('legacy', [
  'wrapper',
  'main-content',
  'inner-content',
  'side-ads',
  'top-ads',
]);

const Legacy = ({ router, adServiceContext }) => {
  const { renderMode } = useContext(AppContext);
  return (
    <div className={styles.block}>
      <div className={styles.wrapper}>
        <div className={styles['main-content']}>
          <div className={styles['top-ads']}>
            <AdContainer
              scalable={!(adServiceContext && adServiceContext.takeover)}
              scaleOrigin="top left"
              scaleParent={`.${styles['top-ads']}`}
              placement="panorama_top"
              min={861}
              max={10000}
            />
          </div>
          <ErrorBoundary onError={() => null}>
            <CookieBanner />
          </ErrorBoundary>
          {renderMode !== 'native' && <LoadableHeader />}

          <section className={styles['inner-content']}>
            <ErrorBoundary onError={() => <ErrorMessage status={500} />}>
              {router}
            </ErrorBoundary>
          </section>

          {renderMode !== 'native' && <LoadableFooter />}
        </div>
        <aside
          className={styles['side-ads']}
          style={
            adServiceContext && adServiceContext.takeover
              ? { 'padding-top': adServiceContext.takeover.height }
              : {}
          }
        >
          <AdContainer placement="skyscraper_1" min={1200} max={10000} />
          <AdContainer placement="skyscraper_2" min={1200} max={10000} />
          <AdContainer placement="skyscraper_3" min={1200} max={10000} />
        </aside>
      </div>
    </div>
  );
};

Legacy.propTypes = {
  router: PropTypes.object.isRequired,
  adServiceContext: AdServiceContextType,
};

Legacy.defaultProps = {
  adServiceContext: {},
};

export default withAds(memo(Legacy));
